export default "__VITE_ASSET__68b8ed56__"